<template>
  <router-link
      :to="{name: 'PetProfile', params: {pet_id: pet.id}}"
      class="pet-link"
  >
    <div class="card pet-card">
        <div class="p-3 mx-4 text-center d-flex justify-content-center">
            <div v-if="avatar_url" class="text-center">
                <img :src="avatar_url" width="128px" height="128px" class="opacity-10 border-radius-lg shadow" style="border: 1px solid #eee" />
            </div>

            <div
                    :class="
          typeof icon === 'object' ? icon.background : 'bg-gradient-success'
        "
                    class="icon icon-shape icon-lg shadow text-center border-radius-lg"
                    v-else
            >
                <i
                        class="opacity-10"
                        :class="typeof icon === 'string' ? icon : icon.component"
                        aria-hidden="true"
                        style="font-size:18pt"
                ></i>
            </div>
        </div>
        <div class="p-3 pt-0 text-center card-body">
            <h6 class="mb-0 text-center">
                {{ title }}
            </h6>
            <div class="text-xl mt-2">{{ description }}</div>
            <div class="text-xl mt-1">
                <span>
                    Вес {{ pet.weight }} кг
                </span>
            </div>
        </div>
    </div>
  </router-link>
</template>

<script>
import storageService from "@/services/storage.service";

export default {
    name: "DashboardPetCard",
    computed: {
        avatar_url() {
          if (!this.pet.avatar_file_id) {
            return null
          }

          return storageService.createShowFileURL(this.pet.avatar_file_id)
        },

        pet_weight_input_size() {
          let len = (this.pet.weight + "").length
          if (!len) {
              len = 2
          }

          len *= 14

          return "width:" + len + "px"
        },
    },
    data() {
        return {
            "weight_changing": false,
            "last_weight": 0.0,
        }
    },
    props: {
        icon: {
            type: [String, Object],
            required: true,
            component: {
                type: String,
            },
            background: {
                type: String,
            },
            default: () => ({
                background: "bg-white",
            }),
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: "",
        },
        value: {
            type: [String, Number],
            default: "",
        },
        pet: {
            name: "pet",
            weight: 5.0,
        },
    },
    mounted() {
      this.last_weight = this.pet.weight
    }
};
</script>

<style>
.pet-card {
  padding-top: 20px;
  padding-bottom: 20px;
}
.pet-weight span {
    border-bottom: 1px dotted #bbb;
    padding: 2px;
}
.save-weight-button {
    color: #2ecc71;
    cursor: pointer;
}
.save-weight-button:hover {
    color: #27ae60;
}
.close-weight-button {
    margin-left: 5px;
    color: #e74c3c;
    cursor: pointer;
}
.close-weight-button:hover {
    color: #c0392b;
}
.pet-card-description {
  text-decoration: none;
}
.pet-link:hover, .pet-link:visited, .pet-link:link, .pet-link:active {
  text-decoration: none;
  color: inherit;
}
</style>
